import React, { useEffect, useRef, useState } from "react";
import "./ServiceCard.css";
import { Link } from "react-router-dom";
import Button from "./Button";

function SerivceCard({ detail }) {
  const cardRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (cardRef.current) observer.observe(cardRef.current);
  }, []);

  return (
    <article
      ref={cardRef}
      className={`blurred-card ${isVisible ? "card-visible" : ""}`}
      aria-label={`${detail.title} ${detail.title_highlight} service card`}
    >
      <h3 className="card-title">
        {detail.title} <span>{detail.title_highlight}</span>
      </h3>

      <p className="card-description">{detail.description.slice(0, 90)}...</p>

      <div className="service-card-btn">
        <Link
          to={`/automationDetails/${detail.id}`}
          aria-label={`Learn more about ${detail.title}`}
        >
          <Button
            btnTitle="Learn more"
            link={`/automationDetails/${detail.id}`}
          />
        </Link>
      </div>
    </article>
  );
}

export default SerivceCard;